import { render, staticRenderFns } from "./setGame8.vue?vue&type=template&id=4d3201bf&"
import script from "./setGame8.vue?vue&type=script&lang=js&"
export * from "./setGame8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports